const MuiFilledInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      backgroundColor: theme.palette.gray.A100,
      '&:before': {
        border: 0,
      },
      '&:hover:before': {
        border: 0,
      },
      height: 47,
    }),
    input: {
      paddingTop: 10,
      paddingBottom: 0,
      lineHeight: '40px',
      display: 'flex',
      alignItems: 'center',
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
        WebkitBackgroundClip: 'text',
      },
    },
    adornedEnd: {
      height: 47,
      display: 'flex',
      alignItems: 'center',
    },
  },
};

export default MuiFilledInput;
